import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IActivityDropdown, IActivityRequest, IActivityResponse } from '../models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class ActivityApiService {
  headers = { 'content-type': 'application/json' };

  constructor(private readonly http: HttpClient) {}

  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/activities`;
  }

  getActivities(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IActivityResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IActivityResponse[]>>(this.url, { params });
  }

  getAllActivitiesForDepartment(departmentId: string): Observable<IActivityDropdown[]> {
    const url = `${
      environment.apiUrl
    }/api/${getTenantId()}/${departmentId}/departmentScope/activities`;
    return this.http.get<IActivityDropdown[]>(url);
  }

  getActivityById(activityId: string): Observable<IActivityResponse> {
    const url = `${this.url}/${activityId}`;
    return this.http.get<IActivityResponse>(url);
  }

  createActivity(activity: IActivityRequest): Observable<IActivityResponse> {
    return this.http.post<IActivityResponse>(this.url, activity, { headers: this.headers });
  }

  updateActivity(update: IActivityRequest): Observable<IActivityResponse> {
    const url = `${this.url}/${update.id}`;
    return this.http.put<IActivityResponse>(url, update, { headers: this.headers });
  }

  deleteActivity(id: string) {
    const url = `${this.url}/${id}`;
    return this.http.delete<IActivityResponse>(url);
  }
}
